<template>
    <div>
        <div v-if="mostrarEntregas">
            <app-entregas
                :entregas="entregasFiltradas"
                :movimentosServicos="obterMovimentosServicos()"
            >
                <template slot="controles">
                    <b-row>
                        <b-col sm="12" md="4">
                            <b-form-group>
                                <strong>
                                    <label>Por Status</label>
                                </strong>
                                <b-form-select
                                    :plain="true"
                                    :options="statusEntregasSelect"
                                    v-model="statusEntregas"
                                ></b-form-select>
                            </b-form-group>
                        </b-col>
                        <b-col sm="12" md="4">
                            <b-form-group>
                                <strong>
                                    <label
                                        >Por Situação do Comprometimento</label
                                    >
                                </strong>
                                <b-form-select
                                    :plain="true"
                                    :options="situacoesEntregasSelect"
                                    v-model="situacaoEntregas"
                                ></b-form-select>
                            </b-form-group>
                        </b-col>
                        <b-col sm="12" md="4">
                            <b-form-group>
                                <strong>
                                    <label>Por Prazo</label>
                                </strong>
                                <b-form-select
                                    :plain="true"
                                    :options="prazosEntregasSelect"
                                    v-model="prazoEntregas"
                                ></b-form-select>
                            </b-form-group>
                        </b-col>
                    </b-row>
                </template>
                <template slot="entregaAcoes" slot-scope="data">
                    <span
                        class="text-primary"
                        v-if="$temAcessoView('CRED-GEST-ENTR-00')"
                    >
                        <i
                            class="fa fa-info-circle fa-lg icon-button"
                            title="Detalhar"
                            @click.stop="detalharEntrega(data.entregaId)"
                        ></i>
                    </span>
                </template>
            </app-entregas>
        </div>
        <router-view></router-view>
    </div>
</template>

<script>
import EntregasServicos from './EntregasServicos'
import Entregas from '@/app/credenciados/componentes/entregas/Entregas2'
import MovimentosServicos from './../movimentos/MovimentosServicos'
import { statusEntregasSelect } from '../../statusEntregasSelect'

export default {
    data() {
        return {
            entregasFiltradas: [],
            entregas: [],
            statusEntregasSelect: statusEntregasSelect,
            statusEntregas: 1,
            situacoesEntregasSelect: [
                { text: 'TODAS', value: -1 },
                { text: 'NÃO COMPROMETIDAS', value: 0 },
                { text: 'ERRO NO COMPROMETIMENTO', value: 1 },
                { text: 'COMPROMETIDAS', value: 2 }
            ],
            situacaoEntregas: -1,
            prazosEntregasSelect: [
                { text: 'TODAS', value: -1 },
                { text: 'ATRASADAS', value: 0 },
                { text: 'NO PRAZO', value: 1 }
            ],
            prazoEntregas: -1
        }
    },

    methods: {
        obterEntregas() {
            this.$store.dispatch('addRequest')
            let filtro = {
                status: this.statusEntregas,
                situacao: this.situacaoEntregas,
                prazo: this.prazoEntregas
            }
            EntregasServicos.obterPorGestor(filtro).then(response => {
                if (response) {
                    if (response.success) {
                        this.entregas = response.data
                        this.filtrarEntregas()
                    } else {
                        this.erros = response.errors
                    }
                }
                this.$store.dispatch('removeRequest')
            })
        },

        detalharEntrega(entregaId) {
            this.$router.push({
                name: 'Gestores_Entregas_Detalhar',
                params: {
                    entregaId: entregaId
                }
            })
        },

        filtrarEntregas() {
            this.entregasFiltradas = [...this.entregas]
            // if (this.statusEntregas === -1) {
            //     this.entregasFiltradas = this.entregas
            // } else {
            //     this.entregasFiltradas = this.entregas.filter(item => {
            //         return item.status === this.statusEntregas
            //     })
            // }
        },

        obterMovimentosServicos() {
            return MovimentosServicos
        }
    },

    computed: {
        mostrarEntregas() {
            return this.$route.name === 'Gestores_Entregas'
        }
    },

    created() {
        this.obterEntregas()
    },

    watch: {
        $route(to) {
            if (to.name === 'Gestores_Entregas') {
                if (this.$store.getters.recarregar) {
                    this.obterEntregas()
                    this.$store.dispatch('setRecarregar', false)
                }
            }
        },

        statusEntregas() {
            this.obterEntregas()
        },

        situacaoEntregas() {
            this.obterEntregas()
        },

        prazoEntregas() {
            this.obterEntregas()
        }
    },

    components: {
        AppEntregas: Entregas
    }
}
</script>
